const EMPTY_DESCRIPTION = '';
const STRING_TYPE = 'string';
const MISSING_DESCRIPTIONS = ['undefined', 'null'];
const NOT_FOUND = -1;

export function salaryDescriptionText(value: string): string {
  if (typeof value !== STRING_TYPE || !value.trim()
    || MISSING_DESCRIPTIONS.indexOf(value.trim()) !== NOT_FOUND) {
    return EMPTY_DESCRIPTION;
  }
  return value;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/salary-description.ts